/* tslint:disable */
/* eslint-disable */
/**
 * MG-DX Pharmacy Counselor API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.2.0
 * Contact: developers@mg-dx.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { tzDate } from "@mgdx-libs/dayjs";
import { exists, mapValues } from "../runtime";

export const PutPrescriptionSharingAgreementRequestBodyTypename = "PutPrescriptionSharingAgreementRequestBody" as const;

/**
 *
 * @export
 * @interface PutPrescriptionSharingAgreementRequestBody
 */
export interface PutPrescriptionSharingAgreementRequestBody {
  /**
   *
   * @type {boolean}
   * @memberof PutPrescriptionSharingAgreementRequestBody
   */
  isPrescriptionSharingAgreed?: boolean;
  /**
   * Resource type name
   * @type {string}
   * @memberof PutPrescriptionSharingAgreementRequestBody
   */
  readonly __typename?: string;
}

export function PutPrescriptionSharingAgreementRequestBodyFromJSON(
  json: any
): PutPrescriptionSharingAgreementRequestBody {
  return PutPrescriptionSharingAgreementRequestBodyFromJSONTyped(json, false);
}

export function PutPrescriptionSharingAgreementRequestBodyFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): PutPrescriptionSharingAgreementRequestBody {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    __typename: PutPrescriptionSharingAgreementRequestBodyTypename,

    isPrescriptionSharingAgreed: !exists(json, "is_prescription_sharing_agreed")
      ? undefined
      : json["is_prescription_sharing_agreed"],
  };
}

export function PutPrescriptionSharingAgreementRequestBodyToJSON(
  object?: PutPrescriptionSharingAgreementRequestBody | null
): any {
  if (object === undefined) {
    return undefined;
  }
  if (object === null) {
    return null;
  }
  const { __typename, ...value } = object;
  return {
    is_prescription_sharing_agreed: value.isPrescriptionSharingAgreed,
  };
}
